import { useCallback, useState } from 'react';

import { ReportGeneratorListItemNormalized } from '../../../../../../../store/reportGenerator/types';

interface UseReportGeneratorItemActionsParams {
  item: ReportGeneratorListItemNormalized;
  onDownload: (item: ReportGeneratorListItemNormalized, onComplete: () => void) => void;
}

export const useReportGeneratorItemActions = ({
  item,
  onDownload,
}: UseReportGeneratorItemActionsParams) => {
  const [actionLoading, setActionLoading] = useState(false);

  const handleDownload = useCallback(() => {
    setActionLoading(true);
    onDownload(item, () => setActionLoading(false));
  }, [item, onDownload]);

  return { actionLoading, handleDownload };
};
